(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FreightPaymentDetailController', FreightPaymentDetailController);

    FreightPaymentDetailController.$inject = ['$scope','$rootScope','$stateParams','previousState','entity','FreightPayment','FreightPaymentCustomService','$uibModal','DateUtils',
        'MiscService'];

    function FreightPaymentDetailController($scope, $rootScope, $stateParams, previousState, entity, FreightPayment, FreightPaymentCustomService, $uibModal, DateUtils,
                                            MiscService) {
        var vm = this;

        vm.freightPayment = entity;
        vm.previousState = previousState.name;
        vm.updateFreightPayment = updateFreightPayment;
        vm.returnRelatedFreightPayments = returnRelatedFreightPayments;
        vm.setScale = setScale;
        vm.nl2br = MiscService.nl2br;
        vm.relatedFreightPayments = [];

        returnRelatedFreightPayments();

        function updateFreightPayment() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/freight-payment/freight-payment-dialog.html',
                controller: 'FreightPaymentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return vm.freightPayment;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(data) {
                vm.freightPayment = data;
                if(data.paymentDate !== null) {
                    vm.freightPayment.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                }
            });
        }

        function returnRelatedFreightPayments() {
            vm.relatedFreightPayments = [];
            if(vm.freightPayment.shipment !== null) {
                FreightPaymentCustomService.returnRelatedFreightPayments(vm.freightPayment.id, vm.freightPayment.shipment.id).then(function(data) {
                    vm.relatedFreightPayments = data.data;
                }, function(error) {
                    ToastrService.error("Failed to get related Freight Payments");
                });
            }
        }

        var unsubscribe = $rootScope.$on('ccsTrApp:freightPaymentUpdate', function(event, result) {
            vm.freightPayment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        }

        function setScale(value, scale) {
            return parseFloat(value).toFixed(scale);
        }
    }
})();
